export const SUBMIT_QUIZ_QUESTION_RESPONSE = `
  mutation SubmitQuizQuestionResponse(
    $clientMutationId: String,
    $quizAttemptId: ID!,
    $quizQuestionId: ID!,
    $userResponse: String!
  ) {
    submitQuizQuestionResponse(input: {
      clientMutationId: $clientMutationId,
      quizAttemptId: $quizAttemptId,
      quizQuestionId: $quizQuestionId,
      userResponse: $userResponse
    }) {
      ... on SubmitQuizQuestionResponsePayload {
        quizAttemptId
        quizQuestionId
      }
    }
  }
`;
